export function maskPhoneNumber(phone: string): string {
  if (!phone) return '';
  
  const digitsOnly = phone.replace(/\D/g, '');
  
  if (digitsOnly.length < 4) {
    return phone;
  }
  
  const lastFour = digitsOnly.slice(-4);
  
  return `(xxx) xxx-${lastFour}`;
}

export function maskEmail(email: string): string {
  if (!email) return '';
  
  const atIndex = email.indexOf('@');
  if (atIndex === -1) {
    return email;
  }
  
  const localPart = email.substring(0, atIndex);
  const domain = email.substring(atIndex);
  
  if (localPart.length === 0) {
    return email;
  }
  
  if (localPart.length === 1) {
    return `${localPart}***${domain}`;
  }
  
  const firstChar = localPart[0];
  const lastChar = localPart[localPart.length - 1];
  
  return `${firstChar}***${lastChar}${domain}`;
}

export function isValidPhone(phone: string): boolean {
  if (!phone) return false;
  const digitsOnly = phone.replace(/\D/g, '');
  return digitsOnly.length >= 10;
}

export function isValidEmail(email: string): boolean {
  if (!email) return false;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}
